import { CircularProgress } from "./CircularProgress";

export default CircularProgress;
